"use client";
import c, { useState as p, useEffect as u } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import N from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import V from "./index.es25.js";
import { createChartOptions as w } from "./index.es70.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import y from "styled-components";
import { extendedRanges as d, chartDataForNullableValueRanges as F, toNamedDistributionValues as I, addAnnotationOptions as L } from "./index.es4.js";
const P = y.div`
  font-weight: bold;
`, f = (t, o, r) => F(t, o, r), g = (t, o, r, a) => {
  const n = I(
    t,
    o,
    r
  ), m = o.categories?.includes("andel") ? "Percent" : "Amount", s = w({
    currentUnits: m,
    chartBackgroundColor: N.colors["sand-5"],
    backgroundColorInit: {
      borders: ["rgba(140, 189, 240,1)"],
      colors: ["rgba(140,189,240,0.6)"]
    },
    title: a
  });
  return L(s, n), { ...s };
}, mt = ({
  distributionData: t,
  regionsData: o,
  keyContext: r,
  year: a,
  title: n,
  onChartChange: m
}) => {
  const [s, h] = p(
    d(t)
  ), i = t.categories?.includes("andel") === !0, [C, b] = p(
    f(s, a, i)
  ), [x, E] = p(
    g(s, t, o, n)
  ), [l, O] = p();
  u(() => {
    const e = d(t), k = f(e, a, i), A = g(e, t, o, n);
    h(e), b(k), E(A);
  }, [t, o, n]), u(() => {
    l && l.update();
  });
  const R = (e) => {
    O(e), m && m(e);
  };
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(P, { className: "bl-text-neutral-1" }, "Kommuner:"), /* @__PURE__ */ c.createElement(
    V,
    {
      keyContext: `${r}-distribution-chart`,
      data: C,
      options: x,
      type: "line",
      onChartChange: R
    }
  ));
};
export {
  mt as default
};
//# sourceMappingURL=index.es160.js.map
